import script from "./FlowingDetail_old.vue?vue&type=script&lang=ts&setup=true"
export * from "./FlowingDetail_old.vue?vue&type=script&lang=ts&setup=true"

import "./FlowingDetail_old.vue?vue&type=style&index=0&id=eb13509e&lang=scss"
import "./FlowingDetail_old.vue?vue&type=style&index=1&id=eb13509e&lang=scss&scoped=true"

import exportComponent from "/apps/jenkins/workspace/client-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-eb13509e"]])

export default __exports__